import moment from 'moment-timezone';
import i18n from 'i18next'

class FilePresenter {
  constructor(fileData) {
    this.uuid = fileData.uuid;
    this.genDocType = fileData.gen_doc_type;
    this.genDocRelevantDate = fileData.gen_doc_relevant_date;
    this.url = fileData.url;
    this.fileName = fileData.file_name;
    this.problem = fileData.problem;
    this.genDocTranscript = fileData.gen_doc_transcript;
  }

  getUUID() {
    return this.uuid;
  }

  getUrl() {
    return this.url;
  }

  // Used in CaseDocumentsList
  getDocName() {
    if (this.hasProblem()) {
      return `${this.fileName} (${this.getProblem()})`;
    } else {
      const docTypeLabel = i18n.t(`case_documents.types.${this.genDocType}`)
      return `${this.fileName} (${docTypeLabel}, ${this.getRelevantDate()})`
    }
  }

  getDocType() {
    return this.genDocType ? i18n.t(`case_documents.types.${this.genDocType}`) : i18n.t('case_documents.types.unknown');
  }

  // Example helper: return a formatted date if needed
  getRelevantDate(format = 'D MMM YYYY') {
    if (!this.genDocRelevantDate) return 'N/A';
    // Assuming moment is available
    return moment.utc(this.genDocRelevantDate).format(format);
  }

  // Used in PatientFileList
  getFileName() {
    return this.fileName;
  }

  // Returns a smartly trimmed file name for display
  getDisplayFileName(maxLength = 40) {
    if (!this.fileName) return '';
    
    if (this.fileName.length <= maxLength) {
      return this.fileName;
    }

    // Split by extension
    const lastDotIndex = this.fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
      // No extension, just trim
      return this.fileName.substring(0, maxLength - 3) + '...';
    }

    const name = this.fileName.substring(0, lastDotIndex);
    const extension = this.fileName.substring(lastDotIndex);
    
    // If extension is long, trim more from name
    const maxNameLength = maxLength - extension.length - 3; // 3 for "..."
    
    if (name.length <= maxNameLength) {
      return this.fileName;
    }
    
    return name.substring(0, maxNameLength) + '...' + extension;
  }

  getProblem() {
    if (this.problem) {
      return this.problem;
    } else if (this.genDocType === null) {
      return i18n.t('case_documents.errors.invalid_file')
    }
  }

  hasProblem() {
    return !!this.problem || (this.genDocType === null);
  }

  getDocTranscript() {
    return this.genDocTranscript;
  }

  // Returns true if the file is not problematic and has a non-blank transcript
  isValid() {
    const transcript = this.getDocTranscript();
    return (
      !this.hasProblem() &&
      typeof transcript === 'string' &&
      transcript.trim() !== ''
    );
  }
}

export default FilePresenter;